import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import logIn from "./user/logIn";
import user from "./user/user";
import profile from "./user/profile";
import menu from "./menu/menu";
import state from "./common/state";
import city from "./common/city";
import toDoCategory from "./common/toDoCategory";
import toDo from "./toDo/toDo";
import toDoManager from "./toDo/toDoManager";
import schedule from "./schedule/schedule";
import service from "./service/service";
import customer from "./customer/customer";
import addressCategory from "./common/addressCategory";
import contactCategory from "./common/contactCategory";
import product from "./product/product";
import productCategory from "./product/productCategory";
import productSubCategory from "./product/productSubCategory";
import template from "./sales/template";
import productPricingRequest from "./sales/productPricingRequest";
import unity from "./common/unity";
import attachment from "./attachment/attachment";
import complexityLevel from "./common/complexityLevel";
import contractorCategory from "./common/contractorCategory";
import contractor from "./common/contractor";
import permit from "./common/permit";
import permitCounty from "./common/permitCounty";
import actions from "./actions/actions";
import customerOrigin from "./common/customerOrigin";
import dashboard from "./dashboard/dashboard";
import workOrder from "./workOrder/workOrder";
import workOrderRequest from "./workOrder/workOrderRequest";
import inspection from "./inspection/inspection";
import inspectionRequest from "./inspection/inspectionRequest";
import promotion from "./promotion/promotion";
import consumerResp from "./consumerResp/consumerResp";
import module from "./common/module";
import serviceCalls from "./serviceCalls/serviceCalls";
import reasonUnclosedDeal from "./common/reasonUnclosedDeal";
import closeJobReason from "./common/closeJobReason";
import appointmentReason from "./common/appointmentReason";
import colorSelectionMaterialType from "./common/colorSelectionMaterialType";
import colorSelectionProduct from "./common/colorSelectionProduct";
import servicePayments from "./service/servicePayments";
import servicePaymentsConfiguration from "./service/servicePaymentsConfiguration";
import docusign from "./docusign/docusign";
import serviceSettings from "./common/serviceSettings";
import report from "./report/report";
import tutorial from "./tutorial/tutorial";
import marketing from "./marketing/marketing";
import warehouse from "./warehouse/warehouse";
import qbVendor from "./quickbooks/qbVendor";
import qbClass from "./quickbooks/qbClass";
import qbTemplate from "./quickbooks/qbTemplate";
import qbPurcharseOrder from "./quickbooks/qbPurcharseOrder";
import todaySchedule from "./todaySchedule/todaySchedule";
import vacation from "./hr/vacation";
import ppe from "./hr/ppe";
import vehicle from "./hr/vehicle";
import inspectionReason from "./inspection/inspectionReason";
import notification from "./notification/notification";
import serviceProjectSetup from "./service/serviceProjectSetup";
import templateEmail from "./templateEmail/templateEmail";
import lotCoverage from "./lotCoverage/lotCoverage";
import equipmentWarranty from "./warranty/equipmentWarranty";
import assistant from "./assistant/assistant";

export default new Vuex.Store({
    modules: {
        logInModule: logIn,
        userModule: user,
        profileModule: profile,
        menuModule: menu,
        stateModule: state,
        cityModule: city,
        toDoCategoryModule: toDoCategory,
        toDoModule: toDo,
        toDoManagerModule: toDoManager,
        scheduleModule: schedule,
        serviceModule: service,
        customerModule: customer,
        addressCategoryModule: addressCategory,
        contactCategoryModule: contactCategory,
        productModule: product,
        productCategoryModule: productCategory,
        productSubCategoryModule: productSubCategory,
        templateModule: template,
        productPricingRequestModule: productPricingRequest,
        unityModule: unity,
        attachmentModule: attachment,
        complexityLevelModule: complexityLevel,
        contractorCategoryModule: contractorCategory,
        contractorModule: contractor,
        permitModule: permit,
        permitCountyModule: permitCounty,
        actionsModule: actions,
        customerOriginModule: customerOrigin,
        dashboardModule: dashboard,
        workOrderModule: workOrder,
        workOrderRequestModule: workOrderRequest,
        inspectionModule: inspection,
        inspectionRequestModule: inspectionRequest,
        promotionModule: promotion,
        consumerRespModule: consumerResp,
        moduleModule: module,
        serviceCallsModule: serviceCalls,
        reasonUnclosedDealModule: reasonUnclosedDeal,
        closeJobReasonModule: closeJobReason,
        appointmentReasonModule: appointmentReason,
        colorSelectionMaterialTypeModule: colorSelectionMaterialType,
        colorSelectionProductModule: colorSelectionProduct,
        servicePaymentsModule: servicePayments,
        servicePaymentsConfigurationModule: servicePaymentsConfiguration,
        docusignModule: docusign,
        serviceSettingsModule: serviceSettings,
        reportModule: report,
        tutorialModule: tutorial,
        marketingModule: marketing,
        warehouseModule: warehouse,
        qbVendorModule: qbVendor,
        qbClassModule: qbClass,
        qbTemplateModule: qbTemplate,
        qbPurcharseOrderModule: qbPurcharseOrder,
        todayScheduleModule: todaySchedule,
        vacationModule: vacation,
        ppeModule: ppe,
        vehicleModule: vehicle,
        inspectionReasonModule: inspectionReason,
        notificationModule: notification,
        serviceProjectSetupModule: serviceProjectSetup,
        templateEmailModule: templateEmail,
        lotCoverageModule: lotCoverage,
        equipmentWarrantyModule: equipmentWarranty,
        assistantModule: assistant,
    },

    state: {
        loader: false,
        loaderMessage: 'Loading...',
        loaderProgress: null,
        modalToDo: false,
        qtdeToDo: 0,
        menuSide: true
    },
    
    mutations: {
        Loader(state, payload) {
            state.loader = payload;
        },

        LoaderMessage(state, payload) {
            state.loaderMessage = payload;
        },

        LoaderProgress(state, payload) {
            state.loaderProgress = payload;
        },

        ModalToDo(state, { payload, qtdeToDo }) {
            
            state.modalToDo = payload;
            state.qtdeToDo = qtdeToDo;
        },

        OpenMenuSide(state, payload) {
            state.menuSide = payload
        }
    }
})

